module.exports = __webpack_public_path__ + "img/ic_about.73a4fa4b.png";